export const selectModelsName = (state) => {
  return state.ModelsReducer.entities.map(model => {
    let id = `id-${model.model.replace(/(?!\w|\s)./g, '')}`;

    return {
      id: id,
      name: model.model,
      description: model.description,
    };
  })
}

export const selectModelDescription = (state) => {
  return state.ModelsReducer.entities.map(model => {
    let id = `id-${model.model.replace(/(?!\w|\s)./g, '')}`;

    return {
      id: id,
      name: model.description,
      description: model.model,
    };
  })
}

export const selectModels = (state) => {
  return state.ModelsReducer.entities.map(model => ({
      id: model.model,
      name: model.model,
  }))
}

export const selectModelsArray = state =>
  state.ModelsReducer.entities.map(model => model.model);
